import { lazy } from 'react'
import { defineFeature } from '@/app/features/types'
import { ROUTES } from '@/app/navigation'

const GeneratePage = lazy(() =>
  import('./GeneratePage').then((module) => ({ default: module.GeneratePage })),
)

export const feature = defineFeature({
  id: 'schedules-generate',
  routes: [
    { path: ROUTES.scheduleGenerate, permission: 'schedule:create', Component: GeneratePage },
  ],
})
